import React, { useState, useContext } from 'react';
import first from 'lodash.first';

import {
  Nav,
  List,
  ListItem,
  DesktopLink,
  DesktopSubList,
  SubLink,
} from './TopicNavigation.style';

import WithNewLabel from 'components/styled/WithNewLabel/WithNewLabel';
import Layout from 'components/styled/Layout/Layout';

import { topicsWithSubTopics } from 'topics';
import { EntityContext } from 'context/entityContext';
import NavIcon from './NavIcon';
import capitalize from 'lodash.capitalize';
import Box from 'components/elements/Box';

interface IDesktopNavProps {
  activeTopic: any;
  getTopicUrl: (topic: any) => string;
}

const DesktopNav: React.FC<IDesktopNavProps> = (props) => {
  const { activeTopic, getTopicUrl } = props;

  const [isOpen, setOpen] = useState(false);
  const open = (): void => setOpen(true);
  let timeout: any;
  const { entityType } = useContext(EntityContext);

  function openMenu(): void {
    timeout = setTimeout(open, 200);
  }

  function closeMenu(): void {
    clearTimeout(timeout);
    setOpen(false);
  }

  return (
    <Layout.MaxWidth isNewDesign isWide>
      <Nav showBackdrop={isOpen} onMouseLeave={closeMenu} id="TopicNavigation">
        <List>
          {topicsWithSubTopics.map((topic) => {
            const { value, children } = topic;

            const to = children ? `${value}/${first(children)?.value}` : value;
            let topics = children;
            if (
              topic?.value === 'overview' &&
              (entityType === 'project' || entityType === 'artist')
            ) {
              topics = topic.children?.filter(
                (topic) => topic.value !== 'certifications'
              );
            }

            if (entityType !== 'track' && topic?.value === 'charts') {
              topics = topic.children?.filter(
                (topic) => topic.value !== 'positionTracker'
              );
            }

            if (entityType !== 'artist' && topic?.value === 'social') {
              topics = topic.children?.filter(
                (topic) => topic.value !== 'linkfire'
              );
            }

            return (
              <ListItem key={value}>
                {children && isOpen && (
                  <DesktopSubList>
                    {topics?.map((child) => (
                      <li key={child.value}>
                        <SubLink
                          to={getTopicUrl(`${topic.value}/${child.value}`)}
                          onClick={closeMenu}
                          // ID for Google Tag Manager trigger
                          id={`TopicNavigation-${child.value}`}
                        >
                          <WithNewLabel isNew={false}>
                            <span>{child.label}</span>
                          </WithNewLabel>
                        </SubLink>
                      </li>
                    ))}
                  </DesktopSubList>
                )}
                <DesktopLink
                  active={value === activeTopic}
                  to={getTopicUrl(to)}
                  onMouseEnter={children ? openMenu : null}
                  onFocus={children ? openMenu : null}
                  onClick={closeMenu}
                  // ID for Google Tag Manager trigger
                  id={`TopicNavigation-${topic.value}`}
                >
                  <Box display="flex">
                    <NavIcon navElementName={value} />
                    <span>{`${
                      topic?.value === 'overview'
                        ? `${capitalize(entityType)} `
                        : ''
                    } ${topic.label}`}</span>
                  </Box>
                </DesktopLink>
              </ListItem>
            );
          })}
        </List>
      </Nav>
    </Layout.MaxWidth>
  );
};

export default DesktopNav;
